type JobBoardPresentationFields = {
  region: string
  updatedAt: string
  deadline?: string
  postedDate?: string
  registeredAt?: string
}

const REGION_ALIASES: Record<string, string> = {
  서울특별시: '서울',
  부산광역시: '부산',
  대구광역시: '대구',
  인천광역시: '인천',
  광주광역시: '광주',
  대전광역시: '대전',
  울산광역시: '울산',
  세종특별자치시: '세종',
  제주특별자치도: '제주',
  경기도: '경기',
  강원특별자치도: '강원',
  충청북도: '충북',
  충청남도: '충남',
  전북특별자치도: '전북',
  전라북도: '전북',
  전라남도: '전남',
  경상북도: '경북',
  경상남도: '경남',
}

const BROAD_REGION_NAMES = new Set([...Object.keys(REGION_ALIASES), ...Object.values(REGION_ALIASES)])
const VIDEO_KEYWORDS = /영상|유튜브|촬영|편집|프리미어|숏폼|쇼츠|릴스|미디어\s*제작|동영상/
const MEDICAL_VIDEO_TERMS = /영상의학(?:과)?|의료\s*영상/g

function stripAdministrativeSuffix(region: string): string {
  return region.replace(/(?:특별자치시|특별자치도|특별시|광역시|시|구|군|도)$/, '')
}

export function isVideoRelatedJob(job: { title: string; category: string }): boolean {
  const searchableText = `${job.title} ${job.category}`.replace(MEDICAL_VIDEO_TERMS, '')
  return VIDEO_KEYWORDS.test(searchableText)
}

export function getJobTitleColorClass(job: { title: string; category: string }): string {
  return isVideoRelatedJob(job) ? 'video-job-title' : 'regular-job-title'
}

function formatDateOnly(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '확인 필요'
  return new Intl.DateTimeFormat('ko-KR', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date)
}

export function formatJobRegion(region: string): string {
  const normalized = region.trim()
  if (!normalized || normalized === '확인 필요') return '확인 필요'

  const parts = Array.from(new Set(normalized.split(/[\s,]+/).filter(Boolean)))
  const city = parts.find((part) => part.endsWith('시') && !BROAD_REGION_NAMES.has(part))
  if (city) return stripAdministrativeSuffix(city)

  const district = parts.find((part) => /[구군]$/.test(part))
  if (district) return stripAdministrativeSuffix(district)

  const aliasedRegion = parts.map((part) => REGION_ALIASES[part]).find(Boolean)
  if (aliasedRegion) return aliasedRegion

  return stripAdministrativeSuffix(parts[0]) || parts[0]
}

export function getJobDateMeta(job: JobBoardPresentationFields): { label: string; value: string } {
  if (job.deadline) return { label: '마감', value: formatDateOnly(job.deadline) }

  const postedDate = job.postedDate || job.registeredAt
  if (postedDate) return { label: '등록', value: formatDateOnly(postedDate) }

  return { label: '업데이트', value: formatDateOnly(job.updatedAt) }
}
